var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReassign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8656 0.856426L17.6456 3.64643C17.8356 3.83643 17.8356 4.15643 17.6356 4.34643L14.8556 7.13643C14.5456 7.45643 14.0056 7.23643 14.0056 6.78643V4.99643H7.99563C7.44563 4.99643 6.99563 4.54643 6.99563 3.99643C6.99563 3.44643 7.44563 2.99643 7.99563 2.99643H14.0156V1.20643C14.0156 0.766426 14.5556 0.536426 14.8656 0.856426ZM0.355635 9.64643L3.13563 6.85643C3.44563 6.53643 3.98563 6.75643 3.98563 7.20643V8.99643H9.99564C10.5456 8.99643 10.9956 9.44643 10.9956 9.99643C10.9956 10.5464 10.5456 10.9964 9.99564 10.9964H3.98563V12.7964C3.98563 13.2364 3.44563 13.4664 3.13563 13.1464L0.355635 10.3564C0.165635 10.1564 0.165635 9.84643 0.355635 9.64643Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReassign);
export default __webpack_public_path__ + "static/media/reassign.e4d62d26a23a21917d072af61174abba.svg";
export { ForwardRef as ReactComponent };